import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'underscore';
import IncidentTable from './IncidentTable';
import { SelectIncidentConfiguration, ToggleIncConfigDialog } from '../../../actions/IncidentTrackerConfigurationActions.js';

const IncidentDetailedTypeTable = (props) => {
	const { className, data, ...rest } = props;
	const dispatch = useDispatch();

	const _incConfigDialogOpen = (rowData, mode) => {
		const item = { id: rowData[0], genericType: rowData[1], type: rowData[2], detailedType: rowData[3] };
		dispatch(SelectIncidentConfiguration({ category: 'detailedType', item }));
		dispatch(ToggleIncConfigDialog(true, mode));
	};

	const _getTableColumns = () => (
		[
			{
				name: 'genericType',
				label: 'Generic Type',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'type',
				label: 'Type',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'detailedType',
				label: 'Detailed Type',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
		]
	);

	return (
		<IncidentTable
			identifier="incidentDetailedTypeTable"
			title="Detailed Type"
			data={data}
			customColumns={_getTableColumns()}
			onEditClick={(rowData) => _incConfigDialogOpen(rowData, 'Update')}
			onDeleteClick={(rowData) => _incConfigDialogOpen(rowData, 'Delete')}
		/>
	);
};

IncidentDetailedTypeTable.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
};

export default IncidentDetailedTypeTable;
